import React, { useState } from "react";
import { Accordion, Button, Form, FormSelect, Modal } from "react-bootstrap";
import { PlusCircleOutlined } from "../../../../helpers/icons/antDesignIcons";
import "../ContainerMoreInfoPage.scss";
import useTranslation from "../../../../hooks/useTranslation";

const ConnectCropToContainerModal = ({
  showConnectCropToContainerModal,
  handleShowConnectCropToContainerModal,
  handleCloseConnectCropToContainerModal,
  containerId,
  cropData,
  listOfCropsInCompany,
  handleSubmitConnectCropToContainerButtonClick,
  handleAddNewCropButtonClick,
  selectedCropToConnectToContainer,
  setSelectedCropToConnectToContainer,
}) => {
  const { t } = useTranslation("locationsPage");
  const { t: cropsPageT } = useTranslation("cropsPage");
  const [cropName, setCropName] = useState("");
  const [description, setDescription] = useState("");
  const [status, setStatus] = useState("");

  const handleSelectChange = (event) => {
    if (event.target.value === "") {
      setSelectedCropToConnectToContainer(null);
      return;
    }

    setSelectedCropToConnectToContainer(event.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const newCrop = {
      cropName,
      description,
      status,
    };

    handleAddNewCropButtonClick(newCrop);

    // Clear the form fields
    /*     setCropName("");
    setDescription("");
    setStatus(""); */
  };

  // Filter the list of crops in the company to exclude those already in the container
  const filteredCrops = listOfCropsInCompany.filter(
    (crop) =>
      !cropData.some((containerCrop) => containerCrop.crops_id === crop._id)
  );

  return (
    <div className="container-crop-more-view-list__wrapper cctcm-wrapper">
      <p>{cropsPageT("cropsManager")}</p>
      <button onClick={handleShowConnectCropToContainerModal}>
        <PlusCircleOutlined />
      </button>
      <Modal
        show={showConnectCropToContainerModal}
        onHide={handleCloseConnectCropToContainerModal}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{cropsPageT("cropsManager")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Accordion defaultActiveKey="0">
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                <strong>{cropsPageT("addNewCrop")}</strong>
              </Accordion.Header>
              <Accordion.Body>
                <Form className="add-crop-form" onSubmit={handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Label>{cropsPageT("cropname")}</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder={cropsPageT("cropname")}
                      required
                      onChange={(e) => setCropName(e.target.value)}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>{t("description")}</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder={t("description")}
                      required
                      onChange={(e) => setDescription(e.target.value)}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>{t("status")}</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder={t("status")}
                      required
                      onChange={(e) => setStatus(e.target.value)}
                    />
                  </Form.Group>
                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      onClick={handleCloseConnectCropToContainerModal}
                    >
                      {t("cancel")}
                    </Button>
                    <Button variant="primary" type="submit">
                      {t("save")}
                    </Button>
                  </Modal.Footer>
                </Form>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header>
                <strong>{cropsPageT("availableCrops")}:</strong>
              </Accordion.Header>
              <Accordion.Body>
                <FormSelect onChange={handleSelectChange}>
                  <option value="">{cropsPageT("chooseACrop")}...</option>
                  {filteredCrops.map((crop, index) => (
                    <option key={index} value={crop._id}>
                      {crop.cropname}
                    </option>
                  ))}
                </FormSelect>{" "}
                <Modal.Footer>
                  <Button
                    variant="secondary"
                    onClick={handleCloseConnectCropToContainerModal}
                  >
                    {t("cancel")}
                  </Button>
                  <Button
                    variant="primary"
                    onClick={() =>
                      handleSubmitConnectCropToContainerButtonClick(
                        containerId,
                        selectedCropToConnectToContainer
                      )
                    }
                  >
                    {t("add")}
                  </Button>
                </Modal.Footer>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleCloseConnectCropToContainerModal}
          >
            {t("cancel")}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ConnectCropToContainerModal;
